import {Injectable} from '@angular/core';

function getWindow(): any {
  // Return the global window only when running in a browser environment
  if (typeof window === 'undefined') {
    return undefined as any;
  }
  return window;
}

@Injectable()
export class WindowReferenceService {
  get nativeWindow() {
    return getWindow();
  }
}
